var _g, _circle, _circle2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRegisterSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 106,
    viewBox: "0 0 131 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2757_15419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65 92.75C86.9533 92.75 104.75 74.9533 104.75 53C104.75 31.0467 86.9533 13.25 65 13.25C43.0467 13.25 25.25 31.0467 25.25 53C25.25 74.9533 43.0467 92.75 65 92.75Z",
    stroke: "#F49600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.75 44.1665H51.7942",
    stroke: "#F49600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.25 44.1665H78.2942",
    stroke: "#F49600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9585 66.25C55.3978 67.719 57.1157 68.886 59.0117 69.6827C60.9077 70.4794 62.9436 70.8898 65.0002 70.8898C67.0567 70.8898 69.0926 70.4794 70.9886 69.6827C72.8846 68.886 74.6025 67.719 76.0418 66.25",
    stroke: "#F49600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 124.5,
    cy: 6.5,
    r: 6.5,
    fill: "#FFEFD7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 95.5,
    r: 4.5,
    fill: "#FFEFD7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2757_15419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 106,
    fill: "white",
    transform: "translate(12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterSuccessIcon);
export default __webpack_public_path__ + "static/media/registerSuccessIcon.df53f60def4a1b1439a85d4768b0762f.svg";
export { ForwardRef as ReactComponent };